import { NgModule } from '@angular/core';
import { CommonModule } from "@angular/common";
import { IonicModule } from 'ionic-angular';
import { PipesModule } from './../pipes/pipes.module';
import { DateService } from './../providers/date.service';

import { EventGraphComponent } from './event-graph/event-graph';
import { RangeGraphComponent } from './range-graph/range-graph';
import { HighchartGraphComponent } from './highchart-graph/highchart-graph';
import { LoadingComponent } from './loading/loading';
import { SleepInputViewComponent } from './sleep-input-view/sleep-input-view';

@NgModule({
    declarations: [
      HighchartGraphComponent,
      LoadingComponent,
      EventGraphComponent,
      RangeGraphComponent,
      SleepInputViewComponent,
    ],
	imports: [PipesModule, CommonModule, IonicModule],
	exports: [
      HighchartGraphComponent,
      LoadingComponent,
      EventGraphComponent,
      RangeGraphComponent,
      SleepInputViewComponent,
    ],
	providers: [
		DateService,
	]
})
export class ComponentsModule {}



// WEBPACK FOOTER //
// ./src/components/components.module.ts